import { type RootContainerProps } from "@client/content/types";
import Heading, { type HeadingProps } from "@client/controls/HTML/Heading/component";
import Slider, { type SliderHandleProps } from "@common/controls/Inputs/Slider/component";
import { formatNumberDisplay } from "@common/lib/format";
import React from "react";
import { getTiersMinMax } from "../lib";
import { type PackagePricing } from "../types";

export type Props = RootContainerProps & {
  headingProps: HeadingProps;
  onChange: (value: number) => void;
  max: number;
  step: number;
  settings: PackagePricing.Settings.Slider;
  tiers: PackagePricing.Api.TierCount[];
  title: string;
  value: number;
};
export default (props: Props) => {
  const minMax = React.useMemo(() => getTiersMinMax(props.tiers, props.max), [props.tiers, props.max]);

  const handle = React.useMemo(
    (): SliderHandleProps => ({
      render: (value: number) => {
        const result = Math.floor(value / props.step) * props.step;
        return <div className="handle">{formatNumberDisplay(Math.max(result, minMax.min))}</div>;
      },
      width: parseInt(props.settings.buttonWidth)
    }),
    [minMax.min, props.step, props.settings.buttonWidth]
  );

  const onChange = React.useCallback(
    (value: number) => props.onChange(Math.floor(value / props.step) * props.step),
    [props.onChange, props.step]
  );

  const paidTiers = React.useMemo(
    () => props.tiers.filter((x) => x.usdMonthPrice || x.usdQuarterPrice || x.usdYearPrice),
    [props.tiers]
  );

  if (!paidTiers.length) return null;

  return (
    <div className="slider_wrap">
      <Heading {...props.headingProps} content={props.title} />

      <Slider
        {...minMax}
        barHeight={props.settings.lineHeight}
        handle={handle}
        fillColor={props.settings.lineColor}
        tailColor={props.settings.lineColor}
        onChange={onChange}
        step={props.step}
        value={props.value}
      />
    </div>
  );
};
